import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { rol } from "../../store/rol/actions";
export var useRolGetAll = function (trigger, clientId, pageCatalog, limitCatalog, name, description, nameSearch) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return ({
        responseRol: state.Rol.responseRol,
        errorRol: state.Rol.errorRol,
        loadingRol: state.Rol.loadingRol,
    }); }), responseRol = _b.responseRol, errorRol = _b.errorRol, loadingRol = _b.loadingRol;
    useEffect(function () {
        if (trigger) {
            dispatch(rol({
                clientId: clientId,
                enable: enable,
                page: pageCatalog,
                limit: limitCatalog,
                name: name,
                description: description,
                nameSearch: nameSearch,
            }));
        }
    }, [trigger, clientId]);
    return {
        responseRol: responseRol,
        errorRol: errorRol,
        loadingRol: loadingRol,
        setEnable: setEnable,
    };
};
